import React, { Fragment, PureComponent } from 'react'
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import {
  Delete,
  MoreVert,
  PersonAdd,
} from '@material-ui/icons'

const menuItems = [
  { id: 'addBooking', label: 'Добавити у відомість', Icon: PersonAdd },
  { id: 'deleteWaitingPassenger', label: 'Видалити', Icon: Delete },
]

export class WaitingPassengerOptions extends PureComponent {
  state = {
    anchorEl: null
  }

  render() {
    return (
      <Fragment>
        <IconButton
          onClick={this.handleOpen}
          className={this.props.classes.moreIcon}
        >
          <MoreVert />
        </IconButton>
        <Menu
          anchorEl={this.state.anchorEl}
          onClose={this.handleClose}
          open={Boolean(this.state.anchorEl)}
        >
          {menuItems.map(this.renderMenuItem)}
        </Menu>
      </Fragment>
    );
  }

  renderMenuItem = ({ id, label, Icon }) => (
    <MenuItem key={id} onClick={this.onOptionClick(id)}>
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText inset primary={label} />
    </MenuItem>
  )

  onOptionClick = type => () => {
    /* eslint-disable */
    switch (type) {
      case 'addBooking':
        this.props.addWaitingPassengerToSheet(this.props.passengerId)
        break
      case 'deleteWaitingPassenger':
        this.props.deleteWaitingPassenger(this.props.passengerId)
        break
      default:
        return
    }
    /* eslint-enable */

    this.handleClose()
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  handleOpen = e => {
    if (this.props.isPartner || this.props.isLimitedDispatcher) {
      return
    }

    this.setState({ anchorEl: e.currentTarget })
  }
}



// WEBPACK FOOTER //
// ./src/components/WaitingPassengerOptions/WaitingPassengerOptions.js